import React from 'react';
import forIn from 'lodash/forIn';
import findIndex from 'lodash/findIndex';

const mmcHost = process.env.REACT_APP_MMC_ENV;
const cwbiHost = process.env.REACT_APP_CI;

class DownloadLayer extends React.Component {
  constructor(props){
    super(props);
    this.startDownload = this.startDownload.bind(this);
  }
  
  startDownload(dltype) {
    //e.preventDefault();
    
    const {layer} = this.props;
    const layerSrc = layer.mapLayer.getSource();
    //const {dltype} =e.currentTarget.dataset
    let dlUrl =null;
    let wfsOut = null;
    let fileType = null;
    let fileExt = null;
    let downloadName = null;
    let displayName;    
    switch(dltype) {
      case 'gtiff':
        fileType='image/tiff';
        fileExt='tiff';
        displayName='Geotiff';
        break;
      case 'shp':
        wfsOut='SHAPEZIP';
        displayName='Shapefile'
        fileType='application/zip';
        fileExt='zip';
        break;
      case 'json':
        wfsOut='geojson';
        displayName='Geojson'
        fileType='application/json';
        fileExt='json';
        break;
      case 'kmz':
        wfsOut='kmz';
        displayName='KMZ'
        fileType='application/vnd.google-earth.kmz';
        fileExt='kmz';
        break;
      case 'sql':
        wfsOut='SPATIALITEZIP';
        displayName='Spatialite'
        fileType='application/zip';
        fileExt='zip';
        break;
      default:
        wfsOut='SHAPEZIP';
        displayName='Shapefile'
        fileType='application/zip';
        fileExt='zip';
        break;        
    }
    if(dltype !=='gtiff' && layer.type !=='TileWMS' && layer.type !=='Vector') {
      const layerParams = layerSrc.getParams();
      
      
      dlUrl = `${layer.url}`;
      forIn(layerParams, function(value, key) {
        let newKey = key;
        let newValue = value;
        if(key==='LAYERS') {
          newKey = 'TYPENAME';
          newValue = value[0];
        }else{
          if(isNaN(value)) {
            newValue = value.replace('#','%23')
          }          
        }
          dlUrl = `${dlUrl}&${newKey}=${newValue}`;
        });
      downloadName=`${layer.layerList[0]}.${fileExt}`;
      dlUrl=`${dlUrl}&SERVICE=WFS&VERSION=1.1.0&REQUEST=GetFeature&outputformat=${wfsOut}&outfile=${layer.layerList[0]}`;
      
    }else if(layer.type ==='Vector' && layer.dlUrl) {
      downloadName=`download.${fileExt}`;
      dlUrl=`${layer.dlUrl}&outputformat=${wfsOut}`;
      
    }else if(layer.layerList[0]==='cog_layer' || layer.layerList[0]==='cog_xyz' || layer.layerList[0]==='flood_extent_raster') {
      const url = layerSrc.getUrls()[0];
      const vars = {};
      const parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
          vars[key] = value;
      });
      downloadName=`${layer.layerList[0]}.${fileExt}`;
      dlUrl = `${cwbiHost}/download/start?LAYERID=${layer.info.layerId}&type=s3&RASTER_INFO_ID=${vars.RASTER_INFO_ID}&TABLE=${vars.TABLE}&TABLE_ID=${vars.TABLE_ID}`;     
    }
    
    return(<a className="btn btn-sm btn-default" key={dlUrl} href={dlUrl} target="_blank" rel="noopener noreferrer" >{displayName}</a>)
  }

  render() {
    const { layer } = this.props;
    const availableOpt =[]
    if(layer.type==='TileWMS') {
      availableOpt.push('gtiff')      
    }else{
      availableOpt.push('shp')
      availableOpt.push('json')    
    }
    return (
      <div style={{display: 'block'}}>
        <hr style={{marginTop:'12px'}}/>
        <div >
        <label className="control-label larger-font">Download:</label>
        <div style={{height:'26px'}} className="btn-toolbar">
          
          <div className="btn-group" role="group">
            {availableOpt.map((val, idx)=>{
                
                const content = this.startDownload(val);
                return(content);
                
              })}
          </div>
          </div>
        
          
        </div>
      </div>
    )
  }
}

export default DownloadLayer;
